<!-- UserReauthDialog.vue -->
<template>
  <v-dialog :model-value="modelValue" max-width="400px" @update:modelValue="onDialogModelUpdate">
    <v-card>
      <v-card-title class="text-h6">재인증 필요</v-card-title>
      <v-card-text>
        회원 탈퇴를 위해 현재 구글 계정을 재인증해 주세요.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" variant="text" @click="onClose">취소</v-btn>
        <v-btn color="red" variant="text" @click="onConfirmReauth">재인증하기</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'UserReauthDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'reauth'],
  methods: {
    onDialogModelUpdate(value) {
      this.$emit('update:modelValue', value);
    },
    onClose() {
      this.$emit('update:modelValue', false);
    },
    onConfirmReauth() {
      this.$emit('reauth');
      this.$emit('update:modelValue', false);
    },
  },
};
</script>
